import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { putAccount } from "../../../../../../Backend/AccountRequests";
// import { FormInput } from "../../../../../../Components";
import "./EditModal.scss";
import { Roles } from "../../../../../../Constants";

export function EditModal({ user, submit, ...props }) {
  const [t] = useTranslation();
  const [userInfo, setUserInfo] = useState(user);

  const putUser = async () => {
    const resp = await putAccount(userInfo);

    if (resp.success) {
      submit();
      props.onHide();
    }
  };

  const ManageAllSchoolsCheck = userInfo.role === Roles.SchoolManager;

  return (
    <Modal size="lg" {...props} centered dialogClassName="edit-modal">
      <Modal.Header className="edit-modal-header" closeButton>
        <div className="title">{t("EditUser")}</div>
      </Modal.Header>
      <Modal.Body className="edit-modal-content">
        <div className="user-form-wrapper">
          {/* <div className="input-wrapper">
            <span className="label">{t("FirstName")}</span>
            <FormInput
              placeholder=""
              type={"text"}
              value={userInfo.firstName}
              change={(x) => {
                setUserInfo({ ...userInfo, firstName: x.firstName });
              }}
              disabled={true}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("Preposition")}</span>
            <FormInput
              placeholder=""
              type={"text"}
              value={userInfo.preposition}
              change={(x) => {
                setUserInfo({ ...userInfo, preposition: x.preposition });
              }}
              disabled={true}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("LastName")}</span>
            <FormInput
              placeholder=""
              type={"text"}
              value={userInfo.lastName}
              change={(x) => {
                setUserInfo({ ...userInfo, lastName: x.lastName });
              }}
              disabled={true}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("Email")}</span>
            <FormInput
              placeholder=""
              type={"text"}
              value={userInfo.email}
              change={(x) => {
                setUserInfo({ ...userInfo, email: x.email });
              }}
              disabled={true}
            />
          </div> */}
          <div
            className="checkbox-wrapper"
            onClick={(x) =>
              setUserInfo({
                ...userInfo,
                hasActionsEnabled: !userInfo.hasActionsEnabled,
              })
            }
          >
            {userInfo.hasActionsEnabled ? (
              <span className="checkbox" title={t("Enabled")}>
                check_box
              </span>
            ) : (
              <span className="checkbox" title={t("Disabled")}>
                check_box_outline_blank
              </span>
            )}
            <span className="label">{t("Actions")}</span>
            <span className="description">{t("ActionsDescription")}</span>
          </div>
          {ManageAllSchoolsCheck && (
            <div
              className="checkbox-wrapper"
              onClick={(x) =>
                setUserInfo({
                  ...userInfo,
                  canManageAllSchools: !userInfo.canManageAllSchools,
                })
              }
            >
              {userInfo.canManageAllSchools ? (
                <span className="checkbox" title={t("Enabled")}>
                  check_box
                </span>
              ) : (
                <span className="checkbox" title={t("Disabled")}>
                  check_box_outline_blank
                </span>
              )}
              <span className="label">{t("CanManageAllSchools")}</span>
              <span className="description">{t("CanManageAllSchoolsDescription")}</span>
            </div>
          )}
        </div>

        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button className="button" onClick={() => putUser()}>
            {t("SaveChanges")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
